// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xr0U","buttons":"styles_buttons__1YW_L"};